<!-- 
	ActionResetPassword
	props: ActionCode
	role: Public -- requires email link to not error
	Called by @/views/AccountActions to allow user to reset password
-->

<template>
	<div class="action-reset-password">
		<div v-if="loading">
			<div class="text-xl pb-4">Please wait...</div>
			<Loading />
		</div>
		<div v-else>
			<div class="text-2xl winwin-gold pb-4">Reset Password</div>
			<div v-if="verifiedCode && !validCode" class="leading-8">
				<div>An error has occured.</div>
				<div class="text-red-400">{{ error }}</div>
				<router-link to="/reset">
					<CustomButton>Request a new password reset email</CustomButton>
				</router-link>
			</div>
			<div v-if="verifiedCode && validCode">
				<div v-if="success">
					<div class="text-xl pb-4">Password Changed</div>
					<div class="pb-4">You can now login with your new password</div>
					<router-link to="/">
						<CustomButton @click="formLogin()" id="cb-gold">Login</CustomButton>
					</router-link>
				</div>
				<div v-else>
					<div class="reset-password">
						<div class="text-lg">Reset your password for email {{ email }}</div>
						<form autocomplete="off" @submit.prevent="handleResetPassword">
							<div class="form-group">
								<input
									v-model="newPassword"
									type="Password"
									placeholder="New Password"
									required
								/>
							</div>
							<div class="form-group">
								<input
									v-model="confirmNewPassword"
									type="Password"
									placeholder="Confirm New Password"
									required
								/>
							</div>
							<CustomButton id="cb-gold">Reset Password</CustomButton>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import firebase from "firebase";

	import CustomButton from "@/components/CustomButton";
	import Loading from "@/components/Loading";

	export default {
		name: "ActionResetPassword",
		props: ["actionCode"],
		components: {
			CustomButton,
			Loading,
		},
		data() {
			return {
				email: null,
				newPassword: "",
				confirmNewPassword: "",
				error: null,
				success: false,
				validCode: null,
				verifiedCode: false,
				loading: true,
			};
		},
		created() {
			const auth = firebase.auth();

			const actionCode = this.$props.actionCode;

			auth
				.verifyPasswordResetCode(actionCode)
				.then((email) => {
					// if action code is valid then allow user to input new password
					this.email = email;
					this.validCode = true;
					this.verifiedCode = true;
					this.loading = false;
				})
				.catch((err) => {
					// if action code is invalid then trigger failure
					this.validCode = false;
					this.verifiedCode = true;
					this.error = err.message;
					this.loading = false;
					console.log(err);
				});
		},
		methods: {
			handleResetPassword() {
				// called by user button press after inputting this.newPassword && this.confirmNewPassword
				const auth = firebase.auth();

				if (this.newPassword === this.confirmNewPassword) {
					// passwords are the same continue
					const actionCode = this.$props.actionCode;
					const newPassword = this.newPassword;

					auth
						.confirmPasswordReset(actionCode, newPassword)
						.then(() => {
							// if action code is valid trigger success
							this.success = true;
						})
						.catch((err) => {
							// if action code is invalid trigger failure
							console.log(err);
							this.error = err.message;
						});
				} else {
					// if password and confirm password are not the same throw modal error
					this.$store.dispatch(
						"setError",
						"<div class='pb-4'>Passwords do not match</div><div>Please try again.</div>"
					);
				}
			},

			formLogin: function() {
				// redirect to @/views/Auth with login component active
				this.register = false;
				this.$store.commit("formLogin", this.register);
			},
		},
	};
</script>
<style scoped>
	.form-group {
		margin: 12.5px 0;
	}

	form .form-group input {
		border-bottom: 1px solid #ffffff;
		width: 270px;
		padding: 1px 3px 5px;
		background-color: transparent;
		color: #ffffff;
	}
</style>
